// extracted by mini-css-extract-plugin
export default {"div":"AccountDeleteForm_div__7JRoO","p":"AccountDeleteForm_p__Dr686","h3":"AccountDeleteForm_h3__48FCH","a":"AccountDeleteForm_a__rhCtK"};